import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';
import { PersistItemsReducer } from 'features/Persist/reducerTypes';
import { StatusReportStatusResponse } from 'services/tenantManagementService';
import { STATUS_REPORT_FETCHING, STATUS_REPORT_SET } from './action';

export const communicationStatusReportReducer = (state = new PersistItemsReducer<StatusReportStatusResponse>(), action: PersistItemsActionType<StatusReportStatusResponse> | FetchingActionType): PersistItemsReducer<StatusReportStatusResponse> => {
	switch (action.type) {
		case STATUS_REPORT_FETCHING:
			const { fetching } = action as FetchingActionType;

			return {
				...state,
				fetching
			}
		case STATUS_REPORT_SET:
			const { items } = action as PersistItemsActionType<StatusReportStatusResponse>;

			const itemsMap: { [id: number]: StatusReportStatusResponse } = items.reduce(
                (map: { [id: number]: StatusReportStatusResponse }, item) => {
					map[item.id] = item;
					return map;
				},
                {}
			);

			return {
				items,
				itemsMap,
				fetching: false,
				isInitialized: true
			}
		default:
			return state;
	}
};
